import React from 'react';
import { X, Calendar, Settings, Edit3, CheckCircle2, Bookmark, Heart, MessageCircle, Bell, HelpCircle, LogOut, Shield, CreditCard, Gift, Award, User, Lock, Eye, ChevronRight } from 'lucide-react';
import { RitualIcon } from './icons/RitualIcon';
interface ProfileDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (section: string) => void;
  onOpenSettings: () => void;
  onOpenHelpCenter: () => void;
  tokenCount: number;
  messageCount?: number;
}
export const ProfileDrawer: React.FC<ProfileDrawerProps> = ({
  isOpen,
  onClose,
  onNavigate,
  onOpenSettings,
  onOpenHelpCenter,
  tokenCount,
  messageCount = 0
}) => {
  if (!isOpen) return null;
  const handleNavigateToProfile = () => {
    onNavigate('twitter_profile');
    onClose();
  };
  const handleNavigateToPrivacySettings = () => {
    onOpenSettings();
    // We need to dispatch an event to open the privacy tab directly
    setTimeout(() => {
      const event = new CustomEvent('setActiveSettingsSection', {
        detail: {
          section: 'privacy'
        }
      });
      document.dispatchEvent(event);
    }, 100);
    onClose();
  };
  return <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm" onClick={onClose} data-id="element-15884">
      <div className="fixed inset-y-0 right-0 max-w-xs w-full bg-white dark:bg-gray-950 border-l border-gray-200 dark:border-gray-800 shadow-xl overflow-y-auto animate-in slide-in-from-right duration-300" onClick={e => e.stopPropagation()} data-id="element-15885">
        <div className="flex items-center justify-between p-4 border-b border-gray-200 dark:border-gray-800" data-id="element-15886">
          <h2 className="font-bold text-xl text-gray-900 dark:text-white" data-id="element-15887">
            Profile
          </h2>
          <button className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-500 dark:text-gray-400" onClick={onClose} data-id="element-15888">
            <X size={18} data-id="element-15889" />
          </button>
        </div>
        {/* Profile Info */}
        <div className="p-4" data-id="element-15890">
          <div className="flex items-center gap-3" data-id="element-15891">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/un38DJe1eXRzCTbzg1byc9/blue_male_eyes.jpg" alt="Profile" className="w-16 h-16 rounded-full object-cover border-2 border-gray-200 dark:border-gray-700" data-id="element-15892" />
            <div data-id="element-15893">
              <div className="flex items-center" data-id="element-15894">
                <h1 className="text-lg font-bold text-gray-900 dark:text-white" data-id="element-15895">
                  Mitch
                </h1>
                <CheckCircle2 size={16} className="ml-1 text-blue-500 dark:text-blue-400" fill="currentColor" data-id="element-15896" />
              </div>
              <p className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-15897">@mitch</p>
            </div>
          </div>
          <div className="flex mt-4" data-id="element-15898">
            <div className="flex items-center mr-4" data-id="element-15899">
              <span className="font-bold mr-1 text-gray-900 dark:text-white" data-id="element-15900">
                42
              </span>
              <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-15901">
                Following
              </span>
            </div>
            <div className="flex items-center" data-id="element-15902">
              <span className="font-bold mr-1 text-gray-900 dark:text-white" data-id="element-15903">
                128
              </span>
              <span className="text-gray-500 dark:text-gray-400 text-sm" data-id="element-15904">
                Followers
              </span>
            </div>
          </div>
          <p className="mt-4 text-sm text-gray-700 dark:text-gray-300" data-id="element-15905">
            AI enthusiast. Looking for meaningful connections in a digital
            world. SinShift VIP member.
          </p>
          <div className="flex items-center mt-2 text-xs text-gray-500 dark:text-gray-400" data-id="element-15906">
            <Calendar size={12} className="mr-1" data-id="element-15907" />
            <span data-id="element-15908">Joined January 2023</span>
          </div>
          <div className="mt-4 flex gap-2" data-id="element-15909">
            <button className="flex-1 py-2 bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 rounded-lg text-sm transition-colors flex items-center justify-center gap-1.5 text-gray-800 dark:text-gray-200" onClick={onOpenSettings} data-id="element-15910">
              <Edit3 size={16} data-id="element-15911" />
              <span data-id="element-15912">Edit Profile</span>
            </button>
            <button className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-700 transition-colors text-gray-800 dark:text-gray-200" onClick={onOpenSettings} data-id="element-15913">
              <Settings size={16} data-id="element-15914" />
            </button>
          </div>
        </div>
        {/* Membership Status */}
        <div className="p-4 bg-gradient-to-r from-purple-900/30 to-pink-900/30 mx-4 rounded-lg mb-4" data-id="element-15915">
          <div className="flex items-center gap-2 mb-2" data-id="element-15916">
            <Award size={18} className="text-pink-400" data-id="element-15917" />
            <span className="font-bold text-gray-900 dark:text-white" data-id="element-15918">
              VIP Member
            </span>
          </div>
          <p className="text-sm mb-2 text-gray-700 dark:text-gray-300" data-id="element-15919">
            Your membership expires in 28 days. Enjoy premium features!
          </p>
          <button className="w-full py-2 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium" onClick={() => {
          onNavigate('subscription');
          onClose();
        }} data-id="element-15920">
            Manage Subscription
          </button>
        </div>
        {/* Menu Items */}
        <div className="space-y-1 p-2" data-id="element-15921">
          <button onClick={handleNavigateToProfile} className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" data-id="element-15922">
            <User size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15923" />
            <span data-id="element-15924">My Profile</span>
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          onNavigate('bookmarks');
          onClose();
        }} data-id="element-15925">
            <Bookmark size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15926" />
            <span data-id="element-15927">Bookmarks</span>
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          onNavigate('favorites');
          onClose();
        }} data-id="element-15928">
            <Heart size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15929" />
            <span data-id="element-15930">Favorites</span>
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          onNavigate('chat');
          onClose();
        }} data-id="element-15931">
            <MessageCircle size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15932" />
            <span data-id="element-15933">Messages</span>
            {messageCount > 0 && <div className="ml-auto bg-blue-500 text-white text-xs px-2 py-0.5 rounded-full" data-id="element-15934">
                {messageCount}
              </div>}
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          // Toggle notifications panel
          onClose();
        }} data-id="element-15935">
            <Bell size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15936" />
            <span data-id="element-15937">Notifications</span>
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          onNavigate('rituals');
          onClose();
        }} data-id="element-15938">
            <RitualIcon size={18} state="default" className="text-gray-600 dark:text-gray-400" data-id="element-15939" />
            <span data-id="element-15940">Daily Rituals</span>
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          onNavigate('token_wallet');
          onClose();
        }} data-id="element-15941">
            <CreditCard size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15942" />
            <span data-id="element-15943">Tokens</span>
            <div className="ml-auto flex items-center gap-1" data-id="element-15944">
              <span className="text-pink-500" data-id="element-15945">💗 {tokenCount}</span>
              <ChevronRight size={16} className="text-gray-500" data-id="element-15946" />
            </div>
          </button>
        </div>
        {/* Privacy & Security Section */}
        <div className="mt-4 p-2" data-id="element-15947">
          <div className="px-4 py-2" data-id="element-15948">
            <p className="text-xs text-gray-500 uppercase font-medium" data-id="element-15949">
              Privacy & Security
            </p>
          </div>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={handleNavigateToPrivacySettings} data-id="element-15950">
            <Lock size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15951" />
            <span data-id="element-15952">Privacy Settings</span>
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          console.log('Content Preferences clicked');
          onClose();
        }} data-id="element-15953">
            <Eye size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15954" />
            <span data-id="element-15955">Content Preferences</span>
          </button>
        </div>
        {/* Support & Logout */}
        <div className="mt-4 p-2 border-t border-gray-200 dark:border-gray-800" data-id="element-15956">
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors text-gray-800 dark:text-gray-200" onClick={() => {
          onOpenHelpCenter();
          onClose();
        }} data-id="element-15957">
            <HelpCircle size={18} className="text-gray-600 dark:text-gray-400" data-id="element-15958" />
            <span data-id="element-15959">Help Center</span>
          </button>
          <button className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg text-red-500 transition-colors" data-id="element-15960">
            <LogOut size={18} data-id="element-15961" />
            <span data-id="element-15962">Log Out</span>
          </button>
        </div>
        <div className="p-4 text-center text-xs text-gray-500" data-id="element-15963">
          <p data-id="element-15964">SinShift AI v1.2.4</p>
          <p className="mt-1" data-id="element-15965">
            <a href="#" className="hover:underline" data-id="element-15966">
              Terms of Service
            </a>{' '}
            •{' '}
            <a href="#" className="hover:underline" data-id="element-15967">
              Privacy Policy
            </a>
          </p>
        </div>
      </div>
    </div>;
};